import React, {Component} from "react";

class HomePlayFormErrorConsole extends Component {
    render() {        
        let {errors, show} = this.props;

        return (
            <div className='home_play_form_error_console'>
                {show && <div className='home_play_form_errors'>{
                    errors.map((errorMessage) => (
                            <div className='home_play_console_error'>{errorMessage}</div>
                        )
                    )
                }
                </div>}
            </div>
        );
    }
}

export default HomePlayFormErrorConsole;


// WEBPACK FOOTER //
// ./src/components/containers/home-play/home-play-form-error-console.js